import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareCodeClassicRoute: InvariantJiraRoute = {
	name: 'software-code-classic',
	path: '/jira/software/c/projects/:projectKey/code',
};
